import axios from 'axios';

export const getPortfolioMappings = (portfolioId) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_URL_BACKOFFICE_API}integration/portfolio-mappings/${portfolioId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }
  });
};

export const startResync = (providerId, portfolioId, forceCustodyAdjustment = false) => {
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_URL_BACKOFFICE_API}integration/start`,
    data: {
      providerId,
      portfolioId,
      forceCustodyAdjustment
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`
    }
  });
};
